module.exports = __webpack_public_path__ + "img/ico_add_client.93d8ba67.svg";